import { request } from 'api/request';
import { PATCH, POST, PRODUCT_RESEARCH_API_URLS } from 'api/constants';

export default class Settings {
  static getAccountSettings() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.user.user,
      isFullError: true,
    });
  }

  static updateAccountSettings(data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.user.user,
      method: PATCH,
      data,
    });
  }

  static getPoliciesSettings() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.policy.policy,
      isFullError: true,
    });
  }

  static updatePoliciesSettings(data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.policy.policy,
      method: PATCH,
      data,
    });
  }

  static getStoreSettings() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.store.store,
      isFullError: true,
    });
  }

  static updateStoreSettings(data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.store.store,
      method: PATCH,
      data,
    });
  }

  static syncProductsSettings() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.store.synchronizeProducts,
      method: POST,
    });
  }

  static getPaymentsSettings() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.paymentDetails.paymentDetails,
      isFullError: true,
    });
  }

  static updatePaymentsSettings(data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.paymentDetails.paymentDetails,
      method: PATCH,
      data,
    });
  }
}
